import { useTaskSidePanel } from './TaskSidePanelContext';

// The drill-in host, rendered once by AppFrame. Every detail view (task / goal / agent-skills / file)
// is now a self-contained centered <Modal> stored in the context's modal slot — it owns its own scrim,
// close and Escape handling and portals over the page, so there is nothing for this host to frame and
// nothing here touches the rail. (This used to render a right-docked <aside> that pushed the content
// pane and collapsed the rail; that side panel was replaced by the DS modal.)
export function TaskSidePanel() {
  const { modal } = useTaskSidePanel();
  return <>{modal}</>;
}
